import { render, staticRenderFns } from "./OrderPCR.vue?vue&type=template&id=6e02f725"
import script from "./OrderPCR.vue?vue&type=script&lang=js"
export * from "./OrderPCR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports